/**
 * @Description Action types for
 * @FileName generatedReportActionTypes.js
 * @Author pgoutam
 * @CreatedOn 16 Jan 23
 * @IssueID 224
 */

export const genReportActionTypes = {
  GENERATE_REPORT_TEMPLATE_REQUEST: 'GENERATE_REPORT_TEMPLATE_REQUEST',
  GENERATE_REPORT_TEMPLATE_RESPONSE: 'GENERATE_REPORT_TEMPLATE_RESPONSE',
  GENERATE_REPORT_TEMPLATE_ERROR: 'GENERATE_REPORT_TEMPLATE_ERROR',
  RESET_GENERATE_REPORT_TEMPLATE_STORE: 'RESET_GENERATE_REPORT_TEMPLATE_STORE',

  LIST_GENERATED_REPORT_REQUEST: 'LIST_GENERATED_REPORT_REQUEST',
  LIST_GENERATED_REPORT_RESPONSE: 'LIST_GENERATED_REPORT_RESPONSE',
  LIST_GENERATED_REPORT_ERROR: 'LIST_GENERATED_REPORT_ERROR',
  LIST_GENERATED_REPORT_RESET: 'LIST_GENERATED_REPORT_RESET',

  DOWNLOAD_GENERATED_REPORT_REQUEST: 'DOWNLOAD_REPORT_TEMPLATE_REQUEST',
  DOWNLOAD_GENERATED_REPORT_RESPONSE: 'DOWNLOAD_GENERATED_REPORT_RESPONSE',
  DOWNLOAD_GENERATED_REPORT_ERROR: 'DOWNLOAD_GENERATED_REPORT_ERROR',
  DOWNLOAD_GENERATED_REPORT_RESET: 'DOWNLOAD_GENERATED_REPORT_RESET',

  DELETE_GENERATED_REPORT_REQUEST: 'DELETE_GENERATED_REPORT_REQUEST',
  DELETE_GENERATED_REPORT_RESPONSE: 'DELETE_GENERATED_REPORT_RESPONSE',
  DELETE_GENERATED_REPORT_ERROR: 'DELETE_GENERATED_REPORT_ERROR',
  DELETE_GENERATED_REPORT_RESET: 'DELETE_GENERATED_REPORT_RESET',

  GET_REPORT_SHARE_INFO_REQUEST: 'GET_REPORT_SHARE_INFO_REQUEST',
  GET_REPORT_SHARE_INFO_RESPONSE: 'GET_REPORT_SHARE_INFO_RESPONSE',
  GET_REPORT_SHARE_INFO_ERROR: 'GET_REPORT_SHARE_INFO_ERROR',

  SAVE_REPORT_SHARE_INFO_REQUEST: 'SAVE_REPORT_SHARE_INFO_REQUEST',
  SAVE_REPORT_SHARE_INFO_RESPONSE: 'SAVE_REPORT_SHARE_INFO_RESPONSE',
  SAVE_REPORT_SHARE_INFO_ERROR: 'SAVE_REPORT_SHARE_INFO_ERROR',

  RESET_REPORT_SHARE_INFO_STORE: 'RESET_REPORT_SHARE_INFO_STORE',
};
